import { initMenu } from "./menu";
import { initPageOverlays } from "./page-overlay";
import { initProductRecommendations } from "./product-recommendations";
import { initSearchBar } from "./search-bar";
import { initSliders } from "./sliders";
import { initTabs } from "./tabs";
import { generateMenuFAQ, movimentCardFAQ } from "./menu-faq";
import { initCopyLink } from "./copy-link";
import { hideBtn } from "./hide-clearAll";
import { initUnderAgePopup } from "./underage";
document.addEventListener("DOMContentLoaded", function () {
  AOS.init({
    startEvent: 'load',
    disableMutationObserver: false
  });
  AOS.refresh(true);
  generateMenuFAQ();
  movimentCardFAQ();
  initSliders();
  initMenu();
  initSearchBar();
  initTabs();
  initProductRecommendations();
  initPageOverlays();
  initCopyLink();
  hideBtn();
  initUnderAgePopup();
});